import { getFormattedMerchGroupUrl } from '@components/pages/ShopLanding/model/prismic';
import { IPrismicImage } from '@lib/prismic/types';
import { IMerchGroup } from '@models/MerchGroup/i-merch-group';
import { MERCH_GROUP_CATEGORY_URL_PREFIX } from '@components/shared/shop/model/MerchGroupCategory';
import { MERCH_GROUP_URL_PREFIX } from '@components/shared/shop/model/MerchGroup';
import _ from 'lodash';

/* eslint-disable camelcase */
interface IFooterImage {
  footer_image: IPrismicImage;
}

export interface IShopNavigationMenuItemOptions {
  image1: IPrismicImage & IFooterImage;
  merch_group_1_id?: number;
  image1_cta_link: string;
  image1_cta_label: string;
  image1_footer_cta_label: string;
  image_1_merch_group: IMerchGroup;
  image2: IPrismicImage & IFooterImage;
  merch_group_2_id?: number;
  image2_cta_link: string;
  image2_cta_label: string;
  image2_footer_cta_label: string;
  image_2_merch_group: IMerchGroup;
  is_dropdown_enabled: boolean;
  navbar_option: string;
}

export interface IShopNavigationMenuItem {
  children: IMerchGroup[];
  title: string;
  slug: string;
  selected?: boolean;
  categoryChildren?: IShopNavigationMenuItem[];
}

export interface IShopNavigationMenu {
  item: IShopNavigationMenuItem;
  url: string;
  option: IShopNavigationMenuItemOptions;
}

export interface IShopNavigationMenuData {
  shop_navigation_menu: IShopNavigationMenuItemOptions[];
}

export const NAVIGATION_SLUGS = {
  FEATURE: 'feature',
  FURNITURE: 'furniture',
  DECOR_PILLOWS: 'decor-pillows',
  RUGS: 'rugs',
  LIGHTING: 'lighting',
  OUTDOOR: 'outdoor',
  SHOP_BY_STYLE: 'shop-by-style',
};

const URL_NAVS = {
  [NAVIGATION_SLUGS.OUTDOOR]: true,
  [NAVIGATION_SLUGS.SHOP_BY_STYLE]: true,
};

export function formatShopNavigationMenu(
  options: IShopNavigationMenuItemOptions[],
  merchGroupsByIdsResult: any,
  items: any[],
): IShopNavigationMenu[] {
  const shopNavigationMenuOptions: { [key: string]: IShopNavigationMenuItemOptions } = {};

  if (options && merchGroupsByIdsResult) {
    options.forEach((option) => {
      if (!shopNavigationMenuOptions[option.navbar_option]) {
        const { merchGroupsByIds } = merchGroupsByIdsResult.data;
        shopNavigationMenuOptions[option.navbar_option] = {
          image1: option.image1,
          image1_cta_link: getFormattedMerchGroupUrl(
            merchGroupsByIdsResult, +option.merch_group_1_id!
          ),
          image1_cta_label: option.image1_cta_label,
          image1_footer_cta_label: option.image1_footer_cta_label,
          image_1_merch_group: merchGroupsByIds.find(
            (mg: IMerchGroup) => +mg.id === +option.merch_group_1_id!
          ) || {},
          image2: option.image2,
          image2_cta_link: getFormattedMerchGroupUrl(
            merchGroupsByIdsResult, +option.merch_group_2_id!
          ),
          image2_cta_label: option.image2_cta_label,
          image2_footer_cta_label: option.image2_footer_cta_label,
          image_2_merch_group: merchGroupsByIds.find(
            (mg: IMerchGroup) => +mg.id === +option.merch_group_2_id!
          ) || {},
          is_dropdown_enabled: option.is_dropdown_enabled,
          navbar_option: option.navbar_option,
        };
      }
    });
  }

  const bySlug = _.keyBy(items.map<IShopNavigationMenu>((item) => {
    let url = `/shop/${item.slug}`;
    if (!(item.slug in URL_NAVS)) {
      if (item.__typename === 'MerchGroupCategory') {
        url = `${MERCH_GROUP_CATEGORY_URL_PREFIX}/${item.slug}`;
      } else if (item.__typename === 'MerchGroup') {
        url = `${MERCH_GROUP_URL_PREFIX}/${item.slug}`;
      }
    }

    return {
      item,
      url,
      option: shopNavigationMenuOptions[item.title] || null,
    };
  }), 'item.slug');

  const menuItems = Object.values(NAVIGATION_SLUGS)
    .map((navSlug) => bySlug[navSlug])
    .filter((item) => item);

  return menuItems;
}
